document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".videos_sliders").forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".videoSlidePrev"),
            nextArrow = slider.parentElement.querySelector(".videoSlideNext");
        new Swiper(slider, {
            direction: "horizontal",
            loop: !0,
            observer: true,            
    observeParents: true,     
    resizeObserver: true,
            speed: 1e3,
            navigation: {
                nextEl: ".videoSlideNext",
                prevEl: ".videoSlidePrev"
            },
            breakpoints: {
                150: {
                    slidesPerView: 1.6,
                    spaceBetween: 10
                },
                576: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                769: {
                    slidesPerView: 3.4,
                    spaceBetween: 20
                },
                1025: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        })
    })
});
function runProductTimer() {
    const timerParent = document.querySelector('.product-timer-parent');
    if (!timerParent) return;

    const endTime = new Date(timerParent.getAttribute('data-endtime')).getTime();

    const x = setInterval(function() {
      const now = new Date().getTime();
      const diff = endTime - now;

      if (diff < 0) {
        clearInterval(x);
        timerParent.innerHTML = "<p>Sale Ended!</p>";
        return;
      }

      // Calculations
      document.getElementById('days').innerText = Math.floor(diff / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
      document.getElementById('hours').innerText = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
      document.getElementById('minutes').innerText = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
      document.getElementById('seconds').innerText = Math.floor((diff % (1000 * 60)) / 1000).toString().padStart(2, '0');

    }, 1000);
  }

  document.addEventListener('DOMContentLoaded', runProductTimer);

  function initializeTopSlider() {
  if (typeof Swiper !== 'undefined') {
    const testiMonialSlider = new Swiper(".topSlider", {
        slidesPerView: 4,
        spaceBetween: 40,
        effect: "slide",
        loopedSlides: 2,
        observer: true,            
    observeParents: true,     
    resizeObserver: true,
        loop: true,
        speed: 600, 
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        breakpoints: {
            1025: {
                slidesPerView: 4,
                spaceBetween: 40
            },
            769: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            576: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            290: {
                slidesPerView: 1,
                spaceBetween: 20
            }
        }
    });
    console.log("Swiper Slider Successfully Initialized!");
  } else {
    setTimeout(initializeTopSlider, 50);
  }
}


if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initializeTopSlider);
} else {
  initializeTopSlider();
}

function initializeSideBarSlider() {
  if (typeof Swiper !== 'undefined') {
    const sideBarSlider = new Swiper(".sideBarSlider", {
        slidesPerView: 1, 
        spaceBetween: 15, 
        effect: "slide",
        loopedSlides: 1,  
        observer: true,            
        observeParents: true,     
        resizeObserver: true,
        loop: true,
        speed: 600,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }, 
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
    });
    console.log("SideBar Swiper Slider Successfully Initialized!");
  } else {
    setTimeout(initializeSideBarSlider, 50);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initializeSideBarSlider);
} else {
  initializeSideBarSlider();
}


      document.addEventListener('DOMContentLoaded', () => {
        Fancybox.bind('[data-fancybox-single]', {
          Carousel: !1,
          Thumbs: !1,
          dragToClose: !1,
          Toolbar: {
            display: {
              left: [],
              middle: [],
              right: ['close'],
            },
          },
          keyboard: {
            ArrowLeft: !1,
            ArrowRight: !1,
            Escape: 'close',
          },
        });
      });